import { IExpenseBasicInfo } from "src/services/interfaces/Expense/IExpenseBasicInfo";

interface IGroupOptions {
  value: keyof IExpenseBasicInfo;
  description: string;
}

export const groupOptions: IGroupOptions[] = [
  {
    value: "createdDate",
    description: "Data de Criação"
  },
  {
    value: "maturityDate",
    description: "Data de Vencimento"
  },
  {
    value: "createdUser",
    description: "Usuário de criação"
  }
];



// WEBPACK FOOTER //
// ./src/components/common/ExpenseList/groupOptions.ts